import React from 'react';

/* Banner stays factual; remind readers the repo is the live source. */
const WorkInProgressBanner: React.FC = () => (
  <div className="lc-banner" role="note" aria-label="Work in progress notice">
    <div className="lc-container lc-banner-inner">
      <span className="lc-banner-badge">v0.2.1-alpha</span>
      <span>
        ZFS unlock works end-to-end. LUKS support is scaffolded. Behaviour, usability and
        platform support may change — the repository is the canonical source of truth.
      </span>
    </div>
  </div>
);

export default WorkInProgressBanner;
